import type {
    IFoldersAPIItem,
    IFoldersAPIResponse,
} from "app/pages/website-analysis/website-structure/pages/Folders/types";

const MOCK_TOTAL_COUNT = 2736;

const normalizeDomain = (domain: string): string => domain.replace(/\/$/, "") || "nike.com";

const buildItem = (
    domain: string,
    specificFolder: string,
    share: number,
    lastMonthShare: number,
    prevMonthShare?: number,
    children?: IFoldersAPIItem[],
): IFoldersAPIItem => {
    const folderPath = specificFolder === "/" ? `${domain}/` : `${domain}${specificFolder}`;

    return {
        Folder: folderPath,
        SpecificFolder: specificFolder,
        Share: share,
        LastMonthShare: lastMonthShare,
        PrevMonthShare: prevMonthShare,
        Children: children,
    };
};

export const getWebsiteContentLockedMockFoldersResponse = (domain: string): IFoldersAPIResponse => {
    const site = normalizeDomain(domain);

    const data: IFoldersAPIItem[] = [
        buildItem(site, "/", 0.182, 0.175, 0.168, [
            buildItem(site, "/us", 0.092, 0.088, 0.084),
            buildItem(site, "/gb", 0.048, 0.045, 0.043),
            buildItem(site, "/eu", 0.042, 0.039, 0.038),
        ]),
        buildItem(site, "/men", 0.124, 0.118, 0.112),
        buildItem(site, "/women", 0.111, 0.108, 0.105),
        buildItem(site, "/kids", 0.086, 0.082, 0.079),
        buildItem(site, "/cart", 0.074, 0.071, 0.069),
        buildItem(site, "/help", 0.063, 0.061, 0.058),
        buildItem(site, "/running", 0.058, 0.055, 0.052),
        buildItem(site, "/basketball", 0.051, 0.049, 0.047),
        buildItem(site, "/soccer", 0.047, 0.044, 0.041),
        buildItem(site, "/sale", 0.043, 0.041, undefined),
        buildItem(site, "/launch", 0.039, 0.037, 0.035),
        buildItem(site, "/membership", 0.034, 0.032, 0.03),
    ];

    return {
        Data: data,
        TotalCount: MOCK_TOTAL_COUNT,
        TotalTopLevelCount: MOCK_TOTAL_COUNT,
    };
};
